import React, {Dispatch, Fragment, useEffect} from 'react';
import {connect} from 'react-redux';
import Plan from '../components/landing/plan';
import Form from '../components/landing/Form';
import Thanks from '../components/landing/Thanks';
import CheckEmail from '../components/landing/CheckEmail';
import '../sass/landing.scss';
import {Container, Navbar, Col} from 'reactstrap';
import { LandingSiteConfig as BaseLandingSiteConfig } from '@integraciones_doc24/wehealthy-api/types/landing';
import {setStepVisible, addStep} from '../reducer/config-reducer';
import {fetchLandingConfig} from '../reducer/config-reducer';

interface LandingSiteConfig extends BaseLandingSiteConfig {
  useAppWeb: boolean;
}
interface propiedades {
  configReducer: {
    stepVisible: string;
    landingConfig: LandingSiteConfig;
  };
  setStepVisible: Dispatch<string>;
  addStep: Dispatch<string>;
  fetchLandingConfig: any;
}

interface configObject {
  configReducer: any;
}

const Landing = (props: propiedades) => {
  const {configReducer, setStepVisible, addStep, fetchLandingConfig} = props;

  const configContent = configReducer?.landingConfig?.content;
  const styles = configReducer?.landingConfig?.styles;
  const useAppWeb = configReducer?.landingConfig?.useAppWeb;

  useEffect(() => {
    fetchLandingConfig();
  }, [fetchLandingConfig]);

  useEffect(() => {
    setStepVisible(configContent?.plans ? 'plans' : 'form');
    addStep(configContent?.plans ? 'plans' : 'form');
  }, [setStepVisible, configContent, addStep]);

  useEffect(() => {
    if (configReducer && configReducer.landingConfig && styles) {
      document.title = styles.pageTitle;
      const favicon = document.querySelector(
        "link[rel~='icon']",
      ) as HTMLLinkElement;
      if (favicon && styles.favicon) {
        favicon.href = styles.favicon;
      }
    }
  }, [configReducer, styles]);

  const shownContent =
    props.configReducer.stepVisible === 'plans' ? (
      <Plan content={configContent?.plans!} />
    ) : props.configReducer.stepVisible === 'form' ? (
      <Form content={configContent?.form} useAppWeb={useAppWeb!} />
    ) : props.configReducer.stepVisible === 'thanks' ? (
      <Thanks content={configContent?.thanks} />
    ) : props.configReducer.stepVisible === 'checkEmail' ? (
      <CheckEmail content={configContent?.emailSent} />
    ) : null;

  return (
    <Fragment>
      {styles && (
        <header style={{background: styles.colors.primary}}>
          <Container>
            <Navbar expand="md">
              <Col md="2" className="mt-3">
                <img
                  src={styles.logo}
                  className="img-fluid"
                  alt="company name"
                />
              </Col>
            </Navbar>
          </Container>
        </header>
      )}
      <div
        className="back-head-landing d-flex flex-column justify-content-center"
        id="landing"
      >
        <Container>
          {configReducer && configReducer.landingConfig && (
            <div>{shownContent}</div>
          )}
        </Container>
      </div>
      {styles && (
        <Fragment>
          <div
            className="text-center pt-4 pb-4"
            style={{
              background: styles.colors.secondary,
              color: styles.colors.primary,
            }}
          >
            Copyright Doc24
          </div>
          <style>
            {Object.entries(styles.colors).map(([key, value]) => {
              return `
                    #landing .background-${key}{
                        background-color: ${value}
                    }
                    #landing .color-${key} {
                        color: ${value}
                    }
                    #landing .border-${key} {
                        border-color: ${value}
                    }
                    #landing .after-border-${key}:after{
                            border-color: ${value} transparent ${value} transparent
                        }
                    `;
            })}
          </style>
          <style>
            {`#landing.back-head-landing{
                            background-image: url(${styles.background});
                            }
                        `}
          </style>
        </Fragment>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    configReducer: state.configReducer,
  };
};

export default connect(mapStateToProps, {
  setStepVisible,
  addStep,
  fetchLandingConfig,
})(Landing);
